import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Colors from "../../../constants/Colors";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CountUp from "react-countup";
import { LottieEmpty } from "../../../components/";
import FeelingEvolutionChart from "../../Recap/FeelingEvolutionChart";
import FirstFeelingChart from "../../Recap/FirstFeelingChart";
import SectionSeparator from "../../Recap/SectionSeparator";
import moment from "moment";
import LeftUserProfile from "./LeftUserProfile";
import RightUserProfile from "./RightUserProfile";

import { connect } from "react-redux";
import {
  selectTab,
  changeField,
  submitComment,
  createManagerSurveyRequest,
  modifyManagerSurveyRequest
} from "../../../services/manager/actions";
import { DialogContent } from "@material-ui/core";
moment.locale("fr");

const styles = theme => ({
  main: {
    height: "100%",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  },
  leftDiv: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    height: "100%"
    // height: "calc(100% - 40px)"
    // minHeight: 500
  },
  rightContainer: {
    height: "100%",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  },
  rightDiv: {
    overflow: "auto",
    height: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: Colors.backGrey,
    flex: 4
    // height: "calc(100% - 40px)"
  },
  picture: {
    borderRadius: 8,
    objectFit: "contain",
    height: "auto",
    // height: "100%",
    width: "100%"
  },
  topLeft: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  bottomLeft: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    padding: 10
  },
  name: {
    fontWeight: 500,
    marginTop: 15
  },
  rank: {
    fontWeight: 500,
    color: Colors.pink
  },
  totalDone: {
    color: Colors.lightBlue,
    fontWeight: 500
  },
  profileStats: {
    marginTop: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "100%"
  },
  totalDoneDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  rangDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  legend: {
    // color: Colors.mediumGrey,
    color: Colors.blackGrey,
    opacity: 0.25
  },
  suggestions: {
    width: "90%",
    marginTop: 10,
    padding: 10,
    backgroundColor: Colors.blackGrey,
    borderRadius: 8,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  suggestionText: {
    color: "#fff"
  },
  italic: {
    fontStyle: "italic"
  },
  textField: {
    borderRadius: 30
  },
  suggestionDiv: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // justifyContent: "flex-end",
    flex: 1
  },
  title: {
    fontWeight: 500,
    marginBottom: 15,
    marginTop: 15
  },
  commentDiv: {},
  firstSection: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "flex-start",
    height: 600,
    display: "flex"
  },
  paper: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    backgroundColor: "#fff",
    // marginTop: 30,
    height: 250,
    padding: 10,
    width: "90%",
    // padding: 5,
    flexDirection: "column",
    display: "flex",
    justifyContent: "center"
  },
  firstSectionLeft: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flex: 1
  },
  firstSectionRight: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  },
  repartition: {
    height: 300,
    display: "flex",
    marginTop: 15
  }
});

class UserProfile extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this._handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown, false);
  }

  _handleKeyDown = e => {
    // Overwrite CMD+S and CTRL+S
    if (
      (window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) &&
      e.keyCode == 83
    ) {
      e.preventDefault();
      this.onSaveManagerSurvey();
    }
  };

  formatFeelingEvolution = feelingEvolution => {
    let data = [];
    feelingEvolution.forEach(el => {
      const month = moment(el.date).format("MMMM");
      const monthIndex = data.findIndex(dataEl => dataEl.mois === month);
      if (monthIndex > -1) {
        data[monthIndex].users++;
        data[monthIndex].Stress += el.stress;
        data[monthIndex].Confiance += el.confidence;
        data[monthIndex]["Aisance à l'oral"] += el.publicSpeaking;
        data[monthIndex]["Cohésion d'équipe"] += el.teamCohesion;
        data[monthIndex]["Productivité"] += el.productivity;
      } else {
        const newData = {
          mois: month,
          monthNumber: moment(el.date).month(),
          users: 1,
          Stress: el.stress,
          Confiance: el.confidence,
          "Aisance à l'oral": el.publicSpeaking,
          "Cohésion d'équipe": el.teamCohesion,
          Productivité: el.productivity
        };
        data.push(newData);
      }
    });
    return data;
  };

  formatFirstFeeling = stats => {
    const result = [
      {
        title: "Stress",
        "Situation initiale": 0
      },
      {
        title: "Confiance",
        "Situation initiale": 0
      },
      {
        title: "Cohésion d'équipe",
        "Situation initiale": 0
      },
      {
        title: "Aisance à l'oral",
        "Situation initiale": 0
      }
    ];
    result[0]["Situation initiale"] = stats.stress;
    result[1]["Situation initiale"] = stats.confidence;
    result[2]["Situation initiale"] = stats.teamCohesion;
    result[3]["Situation initiale"] = stats.publicSpeaking;
    result.forEach(el => {
      el["Objectif"] = 9;
    });
    return result;
  };

  handleChange = name => event => {
    let value = event.target.value;
    this.props.changeField({
      [name]: value
    });
  };

  submitComment = () => {
    this.props.submitComment({
      comment: this.props.userComment,
      userId: this.props.userSelected._id,
      managerId: this.props.userId
    });
  };

  onSaveManagerSurvey = () => {
    if (!this.props.managerSurvey._id) {
      this.props.createManagerSurveyRequest({
        userId: this.props.userSelected._id,
        managerId: this.props.userId,
        survey: this.props.managerSurvey
      });
    }
    this.props.modifyManagerSurveyRequest({
      surveyId: this.props.managerSurvey._id,
      survey: this.props.managerSurvey
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <LeftUserProfile />
        <RightUserProfile />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { userSelected, userComment, managerSurvey } = state.manager;
  const { userId } = state.client;
  return {
    userId,
    userSelected,
    userComment,
    managerSurvey
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {
      changeField,
      submitComment,
      createManagerSurveyRequest,
      modifyManagerSurveyRequest
    }
  )(UserProfile)
);
